import React, { Fragment, useState, useEffect } from "react";
import "./styles.scss";

import { ReactComponent as CancelIcon } from "../../../common/assets/svg/cancel.svg";

import { useSpring, useTransition, animated } from "react-spring";

interface SVGProps {
  isOpen: boolean;
  closePrompt: any;
}

function EnableLocationPrompt(props: SVGProps) {
  const { isOpen, closePrompt } = props;

  const [modalState, setModalState] = useState(false);

  useEffect(() => {
    if (isOpen === false) {
      const timer = setTimeout(() => {
        setModalState(false);
      }, 1000);
      return () => {
        clearTimeout(timer);
      };
    } else {
      setModalState(true);
    }
  }, [isOpen]);

  const opacityProps = useSpring({
    from: { opacity: 0 },
    to: { opacity: isOpen ? 1 : 0 },
  });

  const transitions = useTransition(isOpen, null, {
    from: { transform: "translate3d(0,-15px,0)" },
    enter: { transform: "translate3d(0,0px,0)" },
    leave: { transform: "translate3d(0,-15px,0)" },
    unique: true,
  });

  return (
    <Fragment>
      {modalState ? (
        <>
          {/* <div id="modal-background"></div> */}
          <div className="ELWrapper" style={opacityProps}>
            {transitions.map(({ item, key, props }:any) =>
              item ? (
                <div className="ELContainer" key={key} style={props}>
                  <div className="ELHeader">
                    <span>Enable your Location</span>
                    <CancelIcon onClick={closePrompt} />
                  </div>
                  <div className="ELBody">
                    Restaurants, Dishes and Menu vary for each location. Please
                    enable your location to show the accurate results.
                  </div>
                  <div className="ELFooter">
                    <div className="ELBtn" onClick={closePrompt}>
                      Enable Manually
                    </div>
                  </div>
                </div>
              ) : null
            )}
          </div>
        </>
      ) : null}
    </Fragment>
  );
}

export default EnableLocationPrompt;
